export var TicketSummaryChannel;
(function (TicketSummaryChannel) {
    TicketSummaryChannel[TicketSummaryChannel["CHAT"] = 175] = "CHAT";
    TicketSummaryChannel[TicketSummaryChannel["CALL"] = 150] = "CALL";
})(TicketSummaryChannel || (TicketSummaryChannel = {}));
//# sourceMappingURL=ticket-summary.i.js.map